import moment from 'moment-timezone';
import { environment } from 'environments';

(() => {
  class MessagePoolController {
    constructor($scope, $log, $state, toastr, Messages, Dosespot, localStorageService, Business, $rootScope, Utils) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $log,
        $state,
        toastr,
        Messages,
        Dosespot,
        localStorageService,
        Business,
        $rootScope,
        Utils,
        listCategory: 'null',
        beforeCursor: null,
        afterCursor: null,
        messages: [],
        concatData: [],
        countUsers: 0,
        thereIsMore: false,
        messageSearch: {},
        messageStatuses: [
          {
            id: 0,
            value: 'false',
            name: 'Unread',
          },
          {
            id: 1,
            value: 'true',
            name: 'Read',
          },
        ],
        messageOrderDirections: [
          {
            id: 0,
            value: 'desc',
            name: 'Sort new to old',
          },
          {
            id: 1,
            value: 'asc',
            name: 'Sort old to new',
          },
        ],
        timezone: $rootScope.timezones[0].timezone,
        autoReload: true,
        BOD_1847: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        savePageLocalStorageKey: 'pagination_save_messages_table',
        pagination: {
          limit: 30,
          offset: 0,
          category_id: 0,
          order: 'desc',
          total: 0,
          read: 'false',

          state: [],
          pagination_type: 'offset',
        },
        pageSizeList: [10, 20, 30, 50, 100],
        ungroupedMessages: [],
        BOD_2038: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
      });
      $scope.$on('message-center:refresh', () => {
        // this.load();
        // this.load(true);
        if (this.autoReload) this.BOD_1847 ? this.onPageChange() : this.load(true);
      });
      $scope.$on('message-thread-read', (event, id) => {
        var message = this.messages.find(msg => msg.lastMessage.from.id === id);
        this.messages.splice(this.messages.indexOf(message), 1);
      }); // SECUENCE OF FUNCTIONS:
      //    this.getCategories(); => this.getAvailableStates(); => this.initializeCache(); => this.loadCachedSearchFilters(); => this.load(true);
      // All API data for filters needs to be loaded before we can search messages (or call "load" function)

      this.getCategories();
    }

    $onInit() {
      this.deregister();
    }

    deregister() {
      this.$rootScope.$on('dialog:navigate', (event, navData) => {
        this.$state.go(navData.state, navData.params);
        this.deregister(); // Clean up listener
      });
    }

    formatDate(iso_date) {
      if (!iso_date) return null;
      const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      return formatted_date;
    }

    initializeCache() {
      // Here we initialize the cached filter values
      if (this.localStorageService.get('save_message_search') === undefined)
        this.localStorageService.set('save_message_search', false);
      if (this.localStorageService.get('filter_messageCategory') === undefined)
        this.localStorageService.set('filter_messageCategory', 'Uncategorized');
      if (this.localStorageService.get('filter_showRead') === undefined)
        this.localStorageService.set('filter_showRead', 'false');
      if (this.localStorageService.get('filter_order') === undefined)
        this.localStorageService.set('filter_order', 'desc');
      if (this.localStorageService.get('filter_messageState') === undefined)
        this.localStorageService.set('filter_messageState', []);
    }

    loadCachedSearchFilters() {
      // Here we load the "saved" filter values
      this.savedSearch = this.localStorageService.get('save_message_search');

      if (this.savedSearch) {
        this.messageCategory = this.localStorageService.get('filter_messageCategory');
        this.messageSearch.read = this.localStorageService.get('filter_showRead');
        this.messageSearch.order = this.localStorageService.get('filter_order');
        this.messageSearch.state = this.localStorageService.get('filter_messageState');
        this.states.forEach(s => {
          s.selected = false;
        });

        if (_.isArray(this.messageSearch.state) && this.messageSearch.state.length) {
          this.messageSearch.state.forEach(elem_state => {
            this.states.forEach(s => {
              if (elem_state.code === s.code) {
                s.selected = true;
              }
            });
          });
        }
      } else {
        this.resetFilters();
      }
    }

    resetFilters() {
      // Here we clear the filter values
      this.messageCategory = 'Uncategorized';
      this.messageSearch.read = 'false';
      this.messageSearch.order = 'desc';
      this.states.forEach(s => {
        s.selected = false;
      });
      this.messageSearch.state = [];
    }

    cacheSaveFilter() {
      if (this.savedSearch) {
        this.localStorageService.set('save_message_search', true);
      } else {
        this.localStorageService.set('save_message_search', false);
      }

      this.cacheSearchFilters();
    }

    cacheSearchFilters() {
      // Here we save the filter values
      if (this.savedSearch) {
        this.localStorageService.set('filter_messageCategory', this.messageCategory);
        this.localStorageService.set('filter_showRead', this.messageSearch.read);
        this.localStorageService.set('filter_order', this.messageSearch.order);
        this.localStorageService.set('filter_messageState', this.messageSearch.state);
      } else {
        this.localStorageService.set('filter_messageCategory', 'Uncategorized');
        this.localStorageService.set('filter_showRead', 'false');
        this.localStorageService.set('filter_order', 'desc');
        this.localStorageService.set('filter_messageState', []);
      }
    }

    load(flag) {
      this.cacheSearchFilters();

      if (flag) {
        this.concatData = [];
        this.messages = [];
        this.beforeCursor = null;
        this.afterCursor = null;
        this.thereIsMore = false;
        this.countUsers = 0;
      }

      this.loading = true;
      this.categories.forEach(s => {
        if (this.messageCategory === s.name) {
          this.messageSearch.category_id = s.id;
        }
      });

      if (this.messageCategory === 'Uncategorized') {
        this.messageSearch.category_id = 0;
      }

      var cursor = {};

      if (this.messageSearch.order && this.messageSearch.order === 'asc') {
        cursor.after = this.afterCursor;
      } else {
        cursor.before = this.beforeCursor;
      }

      this.Messages.getAllUnreadMessages(cursor, this.messageSearch)
        .then(({ data }) => {
          this.concatData = this.concatData.concat(data.data); // Group messages by sender

          let threads = _.groupBy(this.concatData, 'from.id');

          if (this.messageSearch.order && this.messageSearch.order === 'asc') {
            // Create custom objects for message pool
            threads = _.map(threads, thread => ({
              // "lastMessage" NOW IT IS ACTUALLY THE "TOP MESSAGE" BECAUSE
              // IF ORDERING OLD TO NEW
              // "lastMessage" WILL BE ACTUALLY THE "FIRST MESSAGE"
              // IF ORDERING NEW TO OLD
              // "lastMessage" WILL BE THE "LAST MESSAGE" (AS USUAL)
              // WE KEEP THE FIELD NAME "lastMessage" FOR COMPATIBILITY
              // lastMessage: thread[thread.length - 1],
              lastMessage: thread[0],
              count: thread.length,
            })); // Sort in chrono order

            this.messages = _.sortBy(threads, 'lastMessage.sent');
          } else {
            // Create custom objects for message pool
            threads = _.map(threads, thread => ({
              // "lastMessage" NOW IT IS ACTUALLY THE "TOP MESSAGE" BECAUSE
              // IF ORDERING OLD TO NEW
              // "lastMessage" WILL BE ACTUALLY THE "FIRST MESSAGE"
              // IF ORDERING NEW TO OLD
              // "lastMessage" WILL BE THE "LAST MESSAGE" (AS USUAL)
              // WE KEEP THE FIELD NAME "lastMessage" FOR COMPATIBILITY
              lastMessage: thread[0],
              count: thread.length,
            })); // Sort in reverse chrono order

            this.messages = _.sortBy(threads, 'lastMessage.sent').reverse();
          } // this.countMessages = this.concatData.length;

          this.$log.debug(this.messages);
          this.countUsers = this.messages.length;
          this.metaData = data['metadata'];

          if (this.messageSearch.order && this.messageSearch.order === 'asc') {
            if (this.messages.length > 0 && data.data.length > 0) {
              this.afterCursor = data.data[data.data.length - 1].id;
            }
          } else {
            if (this.messages.length > 0 && data.data.length > 0) {
              this.beforeCursor = data.data[data.data.length - 1].id;
            }
          }

          if (this.countUsers < 20 && data.data.length > 0) {
            this.load(false);
          }

          if (data.data.length > 0) {
            this.thereIsMore = true;
          } else {
            this.thereIsMore = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

    loadMore() {
      this.loading = true;
      this.categories.forEach(s => {
        if (this.messageCategory === s.name) {
          this.messageSearch.category_id = s.id;
        }
      });

      if (this.messageCategory === 'Uncategorized') {
        this.messageSearch.category_id = 0;
      }

      var cursor = {};

      if (this.messageSearch.order && this.messageSearch.order === 'asc') {
        cursor.after = this.afterCursor;
      } else {
        cursor.before = this.beforeCursor;
      }

      this.Messages.getAllUnreadMessages(cursor, this.messageSearch)
        .then(({ data }) => {
          this.concatData = this.concatData.concat(data.data); // Group messages by sender

          let threads = _.groupBy(this.concatData, 'from.id');

          if (this.messageSearch.order && this.messageSearch.order === 'asc') {
            // Create custom objects for message pool
            threads = _.map(threads, thread => ({
              // "lastMessage" NOW IT IS ACTUALLY THE "TOP MESSAGE" BECAUSE
              // IF ORDERING OLD TO NEW
              // "lastMessage" WILL BE ACTUALLY THE "FIRST MESSAGE"
              // IF ORDERING NEW TO OLD
              // "lastMessage" WILL BE THE "LAST MESSAGE" (AS USUAL)
              // WE KEEP THE FIELD NAME "lastMessage" FOR COMPATIBILITY
              // lastMessage: thread[thread.length - 1],
              lastMessage: thread[0],
              count: thread.length,
            })); // Sort in chrono order

            this.messages = _.sortBy(threads, 'lastMessage.sent');
          } else {
            // Create custom objects for message pool
            threads = _.map(threads, thread => ({
              // "lastMessage" NOW IT IS ACTUALLY THE "TOP MESSAGE" BECAUSE
              // IF ORDERING OLD TO NEW
              // "lastMessage" WILL BE ACTUALLY THE "FIRST MESSAGE"
              // IF ORDERING NEW TO OLD
              // "lastMessage" WILL BE THE "LAST MESSAGE" (AS USUAL)
              // WE KEEP THE FIELD NAME "lastMessage" FOR COMPATIBILITY
              lastMessage: thread[0],
              count: thread.length,
            })); // Sort in reverse chrono order

            this.messages = _.sortBy(threads, 'lastMessage.sent').reverse();
          } // this.countMessages = this.concatData.length;

          this.$log.debug(this.messages);
          this.countUsers = this.messages.length;
          this.metaData = data['metadata'];

          if (this.messageSearch.order && this.messageSearch.order === 'asc') {
            if (this.messages.length > 0 && data.data.length > 0) {
              this.afterCursor = data.data[data.data.length - 1].id;
            }
          } else {
            if (this.messages.length > 0 && data.data.length > 0) {
              this.beforeCursor = data.data[data.data.length - 1].id;
            }
          }

          if (this.countUsers < 20 && data.data.length > 0) {
            this.loadMore();
          }

          if (data.data.length > 0) {
            this.thereIsMore = true;
          } else {
            this.thereIsMore = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

    openThread(message) {
      if (!message) {
        return false;
      }
      if (!this.BOD_1847) {
        const { lastMessage } = message;
        const { id: senderId } = lastMessage.from;
        this.Messages.openChat(senderId);
        return true;
      } else {
        const { id: senderId } = message.from;
        this.Messages.openChat(senderId);
        return true;
      }
    }

    openMessage(message) {
      this.Messages.openChat(message.from.id);
      return true;
    }

    getCategories() {
      this.categories = [];
      this.category_all = {
        id: -1,
        code: 'ALL',
        name: 'All Categories',
      };
      this.category_uncategorized = {
        id: 0,
        code: 'UNCATEGORIZED',
        name: 'Uncategorized',
      };
      this.Messages.getCategories().then(({ data }) => {
        this.categories = data;
        !this.BOD_2038 && this.categories.unshift(this.category_all);
        this.categories.unshift(this.category_uncategorized);
        this.getAvailableStates();
      });
    }

    getAvailableStates() {
      this.Business.getAvailableStates().then(({ data }) => {
        this.states = [];
        data.forEach(state => {
          this.states.push({
            code: state.code,
            name: state.name,
            long_name: state.code + ' - ' + state.name,
          });
        });
        this.initializeCache();
        this.loadCachedSearchFilters();
        this.BOD_1847 ? this.onPageChange() : this.load(true);
      });
    }

    hasMoreUnreadMessages() {
      return this.metaData && this.messages.length < this.metaData.total;
    }

    //pagination and save features
    onPageChange(params = this.pagination) {
      this.loading = true;
      this.Messages.getPaginatedMessages(params)
        .then(({ data }) => {
          if (data.metadata.total < 10) {
            data.metadata.total = 10;
          }
          this.pagination = { ...this.pagination, ...data.metadata };
          this.ungroupedMessages = data.data;
        })
        .catch(err => {
          console.log(err);
          this.messages = [];
        })
        .finally(() => {
          this.loading = false;
        });
    }

    search() {
      const { num_unread, num_unread_from, num_unread_secure, ...paginationWithoutUnread } = this.pagination;
      const params = { ...paginationWithoutUnread, total: 0 };
      this.onPageChange(params);
    }

    sortMessage(messageArray, sortby) {
      messageArray = _.map(messageArray, thread => ({
        lastMessage: thread[0],
        count: thread.length,
      }));

      return sortby === 'asc'
        ? _.sortBy(messageArray, 'lastMessage.sent')
        : _.sortBy(messageArray, 'lastMessage.sent').reverse();
    }

    sortUpdate() {
      this.onPageChange();
    }

    updateStatus() {
      this.pagination.limit = 30;
      this.pagination.offset = 0;
      this.onPageChange();
    }

    emptyStateMessage() {
      return this.pagination.read === 'false' ? 'No Unread Messages' : 'No Messages';
    }
  }

  MessagePoolController.$inject = [
    '$scope',
    '$log',
    '$state',
    'toastr',
    'Messages',
    'Dosespot',
    'localStorageService',
    'Business',
    '$rootScope',
    'Utils',
  ];
  angular.module('pims').controller('MessagePoolController', MessagePoolController);
})();
